import React from 'react';

const cellStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '4px 2px',
    fontSize: '14px',
};

export const tableColumns = [
    {
        name: 'ID',
        selector: row => row.id,
        sortable: true,
        center: true,
        width: '70px',
        style: cellStyle,
    },
    {
        name: 'Seq No',
        selector: row => row.seq_no,
        sortable: true,
        center: true,
        width: '80px',
        style: cellStyle,
    },
    {
        name: 'Thumbnail',
        selector: row => row.thumbnail_url,
        sortable: false,
        center: true,
        width: '110px',
        style: cellStyle,
        cell: row => (
            <div style={{ ...cellStyle, display: 'flex', justifyContent: 'center' }}>
                <img
                    src={row.thumbnail_url || 'https://via.placeholder.com/70x40/CCCCCC/666666?text=No+Image'}
                    alt="Thumbnail"
                    style={{ height: '40px', width: '70px', objectFit: 'cover', borderRadius: '4px' }}
                    onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/70x40/CCCCCC/666666?text=No+Image';
                    }}
                />
            </div>
        ),
    },
    {
        name: 'Title (EN)',
        selector: row => row.title,
        sortable: true,
        center: true,
        width: '180px',
        style: cellStyle,
        cell: row => (
            <div style={{ ...cellStyle, color: '#5662F6', fontWeight: '500', width: '100%', textAlign: 'center' }}>
                {row.title || '—'}
            </div>
        ),
    },
    {
        name: 'Title (HI)',
        selector: row => row.title_hin,
        sortable: false,
        center: true,
        width: '160px',
        style: cellStyle,
        cell: row => (
            <div style={{ ...cellStyle, width: '100%', textAlign: 'center' }}>
                {row.title_hin || '—'}
            </div>
        ),
    },
    {
        name: 'Title (MR)',
        selector: row => row.title_mar,
        sortable: false,
        center: true,
        width: '160px',
        style: cellStyle,
        cell: row => (
            <div style={{ ...cellStyle, width: '100%', textAlign: 'center' }}>
                {row.title_mar || '—'}
            </div>
        ),
    },
    {
        name: 'Title (GJ)',
        selector: row => row.title_guj,
        sortable: false,
        center: true,
        width: '160px',
        style: cellStyle,
        cell: row => (
            <div style={{ ...cellStyle, width: '100%', textAlign: 'center' }}>
                {row.title_guj || '—'}
            </div>
        ),
    },
    {
        name: 'App Version',
        selector: row => row.app_version,
        sortable: true,
        center: true,
        width: '130px',
        style: cellStyle,
        cell: row => (
            <div style={{ ...cellStyle, width: '100%', textAlign: 'center' }}>
                {row.app_version || 'All'}
            </div>
        ),
    },
    {
        name: 'Duration (s)',
        selector: row => row.duration_sec,
        sortable: true,
        center: true,
        width: '120px',
        style: cellStyle,
        cell: row => (
            <div style={{ ...cellStyle, width: '100%', textAlign: 'center' }}>
                {row.duration_sec ?? '—'}
            </div>
        ),
    },
    {
        name: 'Status',
        selector: row => row.status,
        sortable: true,
        center: true,
        id: 'status',
        width: '100px',
        style: cellStyle,
        cell: row => {
            const isActive = row.status === 1 || row.status === 'Active';
            return (
                <span
                    className="d-inline-block"
                    style={{
                        minWidth: '70px',
                        textAlign: 'center',
                        borderRadius: '20px',
                        padding: '4px 8px',
                        backgroundColor: isActive ? '#00C853' : '#9E9E9E',
                        // color: '#FFFFFF',
                        fontSize: '10px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        border: '1px solid rgba(255,255,255,0.1)',
                    }}
                >
                    {isActive ? 'Active' : 'Inactive'}
                </span>
            );
        },
    },
    {
        name: 'Action',
        selector: row => row.action,
        sortable: false,
        center: true,
        width: '150px',
        id: 'action',
        style: cellStyle,
    },
];
